/** @format */
import axios from 'axios';
import qs from 'qs';

import { IntercomIdentityVerification } from '@toucan/common/features/intercom';

// `market` is expected to be lowercase MarketCode
export const getIdentityVerification = async (
    market: string,
    includeContactInformation: boolean = false
) => {
    const queryString = qs.stringify(
        includeContactInformation ? { contact: true } : {},
        { addQueryPrefix: true }
    );

    const result = await axios.get<IntercomIdentityVerification>(
        `/intercom/identity${queryString}`,
        { headers: { 'X-Market': market } }
    );

    return result.data;
};
